import React from "react";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import { ModalPickerProps } from "../props";
import SelectContact from "components/AddressBook/SelectContact";

interface Props extends ModalPickerProps<ContactParticipant> {
  documentId: number;
  mainArea: server.dto.DocumentTypes;
  hasCompany: boolean;
  messageTemplateType: server.dto.MessageTemplateTypes;
}

export interface ContactParticipant {
  contact: server.dto.ContactAddressBookEntry
  culture: server.dto.Culture;
  email: string;
  company?: server.dto.CompanySmall;
  invitationSubject?: string;
  invitationBody?: string;
}

const ContactParticipantModalPicker = (props: Props) => {
  const onChange = (value: ContactParticipant) => {
    props.nonInPageEditing?.onChange(value);
    props.inPageEditing?.onChange(value, true);
  };

  const onContactSelected = async (contact: server.dto.ContactAddressBookEntry, culture: server.dto.Culture, email: string, company: server.dto.CompanySmall) => {
    const defaultTemplate = await window.CoreApi.MessageTemplate.PreferredInvitationTemplateTranslation({ type: props.messageTemplateType, language: culture.language });

    onChange({
      contact,
      culture,
      email,
      company,
      invitationSubject: defaultTemplate.data.data.subject,
      invitationBody: defaultTemplate.data.data.body
    });
  }

  return <>
    <ModalPickerWithChooseButton
      onNewClicked={() => { }}
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={RESX.Contact.Contacts}
      modalSize="small"
      modalHeight={700}
      renderModalContent={(closeModal) => <div className="flex-column grow1" style={{ minHeight: 250 }}>
        <SelectContact
          suggestedApiInstruction={{ itemId: props.documentId, mainArea: props.mainArea }}
          hasNoCompany={!props.hasCompany}
          onContactSelected={async (contact: server.dto.ContactAddressBookEntry, culture: server.dto.Culture, email: string, company: server.dto.CompanySmall) => {
            await onContactSelected(contact, culture, email, company);
            closeModal();
          }}
        />
      </div>}
      renderRemovable={() => <></>}

      {...props}
    />
  </>
};

export default ContactParticipantModalPicker;